import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

import { Subject, combineLatest } from 'rxjs';

@Component({
	selector: 'filtered-drag-drop-groups',
	templateUrl: 'filtered-drag-drop-groups.component.html',
	styleUrls: ['drag-drop-groups.component.css', 'filtered-drag-drop-groups.component.css']
})
export class FilteredDragDropGroupsComponent {
	newLabelGetterSubject = new Subject<void>();
	newLeftListSubject = new Subject<void>();
	
	constructor() {
		// Declencher le tri des qu'on a la premiere liste de valeur et la fonction labelGetter, ou des qu'une des deux valeurs chance
		combineLatest([this.newLabelGetterSubject, this.newLeftListSubject]).subscribe(
			() => this.sortList(this.retainedLeftList)
		);
	}
	
	@Input() parentContainer!: HTMLElement;
	@Input() containerClass!: string;
	@Input() listClass!: string;
	@Input() leftTitle!: string;
	@Input() rightTitle!: string;
	@Input() rightList!: any[];
	
	getLabel!: (item: any) => string;
	@Input() set labelGetter(value: (item: any) => string) {
		this.getLabel = value;
		this.newLabelGetterSubject.next();
	}
	
	filter: string = "";
	retainedLeftList: any[] = [];
	private excludedLeftList: any[] = [];
	@Input() set leftList(values: any[]) {
		this.filter = "";
		this.retainedLeftList = [...values];
		this.excludedLeftList = [];
		this.newLeftListSubject.next();
	}
    get leftList(): any[] {
        return [...this.retainedLeftList, ...this.excludedLeftList];
    }
    
	@Output() changesOccured = new EventEmitter<boolean>();

	dropLeft(event: CdkDragDrop<any[]>) {
		this.drop(event);
		this.applyFilter();
		this.sortList(this.retainedLeftList);
	}

	dropRight(event: CdkDragDrop<any[]>) {
		this.drop(event);
		this.sortList(this.rightList);
	}

	onFilterChange() {
		if (this.filter) {
			this.filter = this.filter.toLowerCase();
		}
		this.applyFilter();
		this.sortList(this.retainedLeftList);
	}

	private drop(event: CdkDragDrop<any[]>) {
		if (event.previousContainer === event.container) {
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		} else {
			transferArrayItem(event.previousContainer.data,
				event.container.data,
				event.previousIndex,
				event.currentIndex);
		}
		this.changesOccured.emit(true);
	}

	private applyFilter() {
		if (!this.filter) {
			this.retainedLeftList.splice(this.retainedLeftList.length, 0, ...this.excludedLeftList);
			this.excludedLeftList = [];
		}

		let newExcludedItems: any[] = this.extract(
			this.retainedLeftList,
			(item: any) => {
				let label: string | undefined = this.getLabel(item);
				let lowerCaseLabel: string = label ? label.toLowerCase() : "";
				return !lowerCaseLabel.includes(this.filter);
			}
		);
		
		let newIncludedItems: any[] = this.extract(
			this.excludedLeftList,
			(item: any) => {
				let label: string | undefined = this.getLabel(item);
				let lowerCaseLabel: string = label ? label.toLowerCase() : "";
				return lowerCaseLabel.includes(this.filter);
			}
		);
		
		this.retainedLeftList.splice(this.retainedLeftList.length, 0, ...newIncludedItems);
		this.excludedLeftList.splice(this.excludedLeftList.length, 0, ...newExcludedItems);
	}
	
	private extract(list: any[], filter: (item: any) => boolean): any[] {
		let extractedItems: any[] = [];
		let index = 0;
		
		while (index < list.length) {
			let item: any = list[index];
			if (filter(item)) {
				extractedItems.push(item);
				list.splice(index, 1);
			} else {
				index++;
			}
		}
		
		return extractedItems;
	}
	
	private sortList(list: any[]): void {
		list.sort(
			(item1: any, item2: any) => {
				let label1: string | undefined = this.getLabel(item1);
				if (!label1) {
					return 1;
				}
				let label2: string | undefined = this.getLabel(item2);
				if (!label2) {
					return -1
				};
				return label1.localeCompare(label2);
			}
		);
	}
}